/*eslint-disable*/
import _ from 'lodash'
import GradeApi from '../../api/grade'

export default [
    {
        path: 'grade/create',
        name: 'grade:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "grades" */'../../components/grade/Create.vue'),
        meta: {
            title: 'router.router_addGrade',
            prev: {
                name: 'grade:list'
            }
        }

    },
    {
        path: 'grade/:id',
        name: 'grade:profile',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "grades" */'../../components/profiles/Grade.vue'),
        meta: {
            title: _.throttle((route) => {
                return GradeApi.show(route.params.id).then((grade) => {
                    return grade.name;
                });
            },100 , {trailing: false}),
            prev: {
                name: 'grade:list'
            }
        },
        props: true
    },
    {
        path: 'grade/:id/edit',
        name: 'grade:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "grades" */'../../components/grade/Edit.vue'),
        meta: {
            title: 'router.router_editGrade',
            prev: {
                name: 'grade:profile'
            }
        },
        props: true
    },
]

